import React from 'react';

import DA from '../store/ReduxAccess';

import SmsSettings from '../components/SmsSettings';

const TwilioInfoPage = () => {
  const firmId = DA.getIntendedAccountId();
  return <SmsSettings firmId={firmId} />;
};

export default TwilioInfoPage;
